import React, { useRef, useState } from 'react';
import axios from 'axios';
import { apiUrl } from '../utils/api';
import { COLUMNS } from './packToroDrafts';

const errorMessages = (value) => typeof value === 'string' ? [value] : value && typeof value === 'object' ? Object.values(value).flatMap(errorMessages) : [];

export default function PackToroExcelImport({ protocolo, rows, disabled, onImport, lote = '' }) {
  const [preview, setPreview] = useState(null);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const requestId = useRef(0);
  const fileInput = useRef(null);
  const existing = new Set(rows.filter((row) => row.muestra_activa !== false && row.identificacion?.trim()).map((row) => row.identificacion.trim().toLocaleLowerCase()));
  const duplicates = (preview || []).filter((row) => row.identificacion?.trim() && existing.has(row.identificacion.toLocaleLowerCase()));

  const review = async (file) => {
    const id = ++requestId.current;
    setPreview(null); setErrors([]); setLoading(false);
    if (!file) return;
    if (!file.name.toLowerCase().endsWith('.xlsx') || file.size > 5 * 1024 * 1024) {
      setErrors(['Selecciona un archivo .xlsx de hasta 5 MB.']); fileInput.current.value = ''; return;
    }
    setLoading(true);
    const payload = new FormData(); payload.append('archivo', file);
    if (lote) payload.append('protocolo_lote', lote);
    try {
      const { data } = await axios.post(apiUrl(`/api/pack-toro/${protocolo}/excel/revisar/`), payload, { headers: { Authorization: `Token ${localStorage.getItem('token') || ''}` } });
      if (id === requestId.current) setPreview(data.filas);
    } catch (error) {
      if (id === requestId.current) {
        setErrors(errorMessages(error.response?.data).length ? errorMessages(error.response.data) : ['No se pudo revisar el Excel. Selecciona el archivo nuevamente para reintentar.']);
        if (fileInput.current) fileInput.current.value = '';
      }
    } finally { if (id === requestId.current) setLoading(false); }
  };

  return <details className="mb-3">
    <summary>Importar muestras y resultados desde Excel</summary>
    <p className="small mt-2">Una fila por carga individual del lote seleccionado. Archivo .xlsx de hasta 5 MB. Encabezados: Identificación, Cantidad de muestras, {COLUMNS.map(([, label]) => label).join(', ')}. La identificación y los resultados pueden quedar vacíos.</p>
    <label htmlFor="pack-excel-file" className="form-label">Archivo Excel de muestras y resultados (.xlsx)</label>
    <input ref={fileInput} id="pack-excel-file" type="file" accept=".xlsx" className="form-control" disabled={disabled} onChange={(event) => review(event.target.files?.[0])} />
    {loading && <p role="status">Revisando Excel…</p>}
    {errors.length > 0 && <div role="alert" className="alert alert-danger mt-2">{errors.map((error, index) => <p key={index}>{error}</p>)}</div>}
    {preview && <div className="mt-2">
      <p role="status">{preview.length} animales revisados. Revisa las muestras y los resultados antes de agregarlos.</p>
      {duplicates.length > 0 && <p role="alert">Ya existen en este caso o borrador: {duplicates.map((row) => row.identificacion).join(', ')}. Corrige el archivo para evitar duplicados.</p>}
      <div className="pack-preview"><table className="table table-bordered table-sm"><thead><tr><th>Identificación</th><th>Cantidad</th>{COLUMNS.map(([field, label]) => <th key={field}>{label}</th>)}</tr></thead>
        <tbody>{preview.map((row, index) => <tr key={index}><td>{row.identificacion}</td><td>{row.numero_de_muestras}</td>{COLUMNS.map(([field]) => <td key={field}>{row[field] || '—'}</td>)}</tr>)}</tbody>
      </table></div>
      <button className="btn btn-outline-brand mt-2" disabled={disabled || loading || duplicates.length > 0 || !preview.length} onClick={() => {
        onImport(preview); setPreview(null); setErrors([]); fileInput.current.value = '';
      }}>Agregar muestras y resultados revisados</button>
      <p className="small mt-2">Se agregarán al borrador. Guarda las muestras para confirmar también sus resultados.</p>
    </div>}
  </details>;
}
